import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBaseLink } from '../../../components/items-list/list-row/list-row-item/list-row-item-base-link';

@Component({
    selector: 'fi-list-sms-message',
    templateUrl: './list-sms-message.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./list-sms-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ListSmsMessageComponent extends ItemsListRowItemBaseLink {}
